module.exports = __webpack_public_path__ + "avatar-default-874a5ab4.jpg";